import { render, staticRenderFns } from "./CustomizableTable.vue?vue&type=template&id=7228cb86&"
import script from "./CustomizableTable.vue?vue&type=script&lang=js&"
export * from "./CustomizableTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports